import React, { ReactNode } from 'react'
import { useParams } from 'react-router-dom'
import { Box } from '@mui/material'
import { useGetCategories } from 'hooks/useCategories'
import { getTranslations } from 'common/utils'
import CategorySection from '../CategorySection/CategorySection'
import { CategoryProvider } from 'context/CategoryContext'

type Props = {
  // Where drilling into a category navigates to. The tree walks the taxonomy
  // the same way whichever page is under it - only the row of things each
  // section carries changes.
  basePath?: string
  renderCarousel?: () => ReactNode
  showAdd?: boolean
  // A word beside each category's name, for a page that has something to say
  // about how full the category is.
  subtitleFor?: (categoryId: string) => string | undefined
}

export default function CategoryTree({
  basePath = '/categories/all-categories',
  renderCarousel,
  showAdd = true,
  subtitleFor,
}: Props) {
  const { categoryId } = useParams<{ categoryId?: string }>()

  const { data: categories = [] } = useGetCategories(categoryId || 'root', {
    select: (res: { data: any[] }) => res.data,
    onSuccess: (data: any[]) => console.log('category data', data),
  })

  return (
    <>
      {categories.map((item: any, index: number) => {

        return (
          <CategoryProvider category={item} key={item.id}>
            <Box mt={index === 0 ? 0 : 3}>
              <CategorySection
                basePath={basePath}
                carousel={renderCarousel?.()}
                showAdd={showAdd}
                subtitle={subtitleFor?.(item.id)}
              />
            </Box>
          </CategoryProvider>
        )
      })}
    </>
  )
}
